import React, { useState, useEffect } from 'react';
import { Button, Dropdown, DropdownButton, Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import { useSelector, useDispatch } from 'react-redux';
import { templateActions } from '../../actions';

import PageTitle from "../../components/common/PageTitle";
import AuthImage from "../../components/common/AuthImage";

const TemplateList = () => {

  const { SearchBar } = Search;
  const dispatch = useDispatch();
  const loading = useSelector(state => state.template.status);
  const group = useSelector(state => state.authentication.user.group);
  const templates = useSelector(state => state.template.templates);
  const [statusFilter, setStatusFilter] = useState('');
  const [premiumFilter, setPremiumFilter] = useState('');
  const [updatedSort, setUpdatedSort] = useState('');

  useEffect(() => {
    dispatch(
      templateActions.search({ educationOnly: true }, true),
    );
  }, [dispatch])

  const updateTemplate = (id, params) => {
    dispatch(templateActions.update(id, params))
  }

  const changePrice = (templateId, price) => {
    const templatePrice = price ? 1 : 0;
    updateTemplate(templateId, { price: templatePrice });
  }
  const changeInvisible = (templateId, invisible) => {
    updateTemplate(templateId, { templateId, invisible });
  }

  const priceIconTooltip = (props) => (
    <Tooltip id="priceTooltip" {...props}>
      {`${!props.price ? 'Free ' : 'Premium '}`}<span style={{ opacity: .5 }}>(click to change)</span>
    </Tooltip>
  );
  const invisibleIconTooltip = (props) => (
    <Tooltip id="invisibleTooltip" {...props}>
      {`${props.invisible ? 'Unpublished ' : 'Published '}`}<span style={{ opacity: .5 }}>(click to change)</span>
    </Tooltip>
  );
  const invisibleIconTooltipJustShow = (props) => (
    <Tooltip id="invisibleTooltip" {...props}>
      {`${props.invisible ? 'Unpublished ' : 'Published '}`}
    </Tooltip>
  );

  const columns = [
    {
      text: '#',
      dataField: 'data.tempId',
      sort: true,
    },
    {
      text: 'Preview',
      dataField: 'src',
      formatter: previewFormatter,
    },
    {
      text: 'Name',
      dataField: 'data.name',
      sort: true,
    },
    {
      text: 'Status',
      dataField: 'data.invisible',
      formatter: invisibleFormatter,
      filter: textFilter({ defaultValue: statusFilter }),
    },
    {
      text: 'Premium',
      dataField: 'data.price',
      formatter: priceFormatter,
      filter: textFilter({ defaultValue: premiumFilter }),
    },
    {
      text: 'Categories',
      dataField: 'data.categories',
      sort: true,
    },
    {
      text: 'Tags',
      dataField: 'data.tags',
      formatter: tagsFormatter,
    },
    {
      text: 'Last Updated',
      dataField: 'data.updatedAt',
      formatter: dateFormatter,
      sort: true,
      sortFunc: dateSort,
    },
    {
      text: 'Action',
      dataField: 'data.id',
      formatter: actionFormatter,
    }
  ]

  function previewFormatter(cell, row) {
    return (
      <AuthImage src={cell} className="tableTempPreview" alt={row.data.name} />
    )
  }
  function priceFormatter(cell, row) {
    return (
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={priceIconTooltip({ price: cell })}
      >
        <span onClick={() => changePrice(row.data.id, !cell)} className={`tableIcon ${!cell ? 'tableFreeIcon' : 'tablePremiumIcon'}`} ></span>
      </OverlayTrigger>
    )
  }
  function invisibleFormatter(cell, row) {
    if (group === 'vibino') {
      return (
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={invisibleIconTooltip({ invisible: cell })}
        >
          <span onClick={() => changeInvisible(row.data.id, !cell)} className={`tableIcon ${!cell ? 'tablePublishedIcon' : 'tableUnpublishedIcon'}`} ></span>
        </OverlayTrigger>
      )
    } else {
      return (
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={invisibleIconTooltipJustShow({ invisible: cell })}
        >
          <span className={`tableIcon ${!cell ? 'tablePublishedIcon' : 'tableUnpublishedIcon'}`} style={{ cursor: 'auto' }} ></span>
        </OverlayTrigger>
      )
    }
  }
  function tagsFormatter(cell, row) {
    if (!cell) return;
    return (
      <div className="tableTagBox">
        {cell.map((tag,i) => {
          return (
            <span className="tableTags" key={i}>{tag}</span>
          );
        })}
      </div>
    )
  }
  function actionFormatter(cell, row) {
    return (
      <div className="tableTempActionBox">
        <Button className="tableTempAction" onClick={() => designHandler(cell, row.data.tempId)}><i className="material-icons">design_services</i> Design</Button>
        <Button className="tableTempAction" onClick={() => editHandler(cell)}><i className="material-icons">edit</i> Edit</Button>
        {/* <Button disabled className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
      </div>
    )
  }

  const designHandler = (_id, tempId) => {
    // history.push(`template/${tempId}/edit`);
    // window.open(`${process.env.REACT_APP_DESIGN_EDITOR}/design/${_id}/${tempId}`, '_blank');
    window.open(`${process.env.REACT_APP_DESIGN_EDITOR}/edit/template/${_id}/${tempId}`, '_blank');
  }

  const editHandler = (tempId) => {
    // history.push(`template/${tempId}/edit`);
    window.open(`template/${tempId}/edit`, '_blank');
  }

  const options = {
    paginationTotalRenderer: customTotal,
    showTotal: true,
    onSizePerPageChange: (sizePerPage, page) => {
      // console.log('Size per page change!!!');
      // console.log('Newest size per page:' + sizePerPage);
      // console.log('Newest page:' + page);
    },
    onPageChange: (page, sizePerPage) => {
      // console.log('Page change!!!');
      // console.log('Newest size per page:' + sizePerPage);
      // console.log('Newest page:' + page);
    }
  };

  function customTotal(from, to, size) {
    return (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );
  }
  function dateFormatter(cell) {
    const date = new Date(cell);
    return cell && !Number.isNaN(date.getTime()) ? date.toLocaleString() : '-';
  }
  function dateSort(left, right, order) {
    const leftTime = new Date(left || 0).getTime();
    const rightTime = new Date(right || 0).getTime();
    return order === 'asc' ? leftTime - rightTime : rightTime - leftTime;
  }

  const statusFilterBtnHandler = (filter) => {
    setStatusFilter(filter)
  }
  const premiumFilterBtnHandler = (filter) => {
    setPremiumFilter(filter)
  }
  const updatedSortBtnHandler = (sortOrder) => {
    setUpdatedSort(sortOrder);
    dispatch(
      templateActions.search(
        {
          educationOnly: true,
          ...(sortOrder ? { sortBy: 'updatedAt', sortOrder } : {}),
        },
        true,
      ),
    );
  }

  return (
    <Container fluid className="main-content-container px-4 templateList">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Templates List" subtitle="Templates" className="text-sm-left" />
      </Row>
      <Row noGutters className="dateFilterRow">
        <Col md="3">
          <span style={{ display: 'block', marginBottom: '-15px' }}>Template Status:</span>
          <DropdownButton
            id="template-status-filter"
            title={statusFilter ? (statusFilter === 'true' ? 'Unpublished' : 'Published') : 'All'}
            variant={statusFilter ? (statusFilter === 'true' ? 'danger' : 'success') : 'secondary'}
          >
            <Dropdown.Item onSelect={() => statusFilterBtnHandler('')} >All</Dropdown.Item>
            <Dropdown.Item onSelect={() => statusFilterBtnHandler('false')} >Published</Dropdown.Item>
            <Dropdown.Item onSelect={() => statusFilterBtnHandler('true')} >Unpublished</Dropdown.Item>
          </DropdownButton>
        </Col>
        <Col md="3">
          <span style={{ display: 'block', marginBottom: '-15px' }}>Template Price:</span>
          <DropdownButton
            id="template-price-filter"
            title={premiumFilter ? (premiumFilter === '0' ? 'Free' : 'Premium') : 'All'}
            variant={premiumFilter ? (premiumFilter === '0' ? 'danger' : 'success') : 'secondary'}
          >
            <Dropdown.Item onSelect={() => premiumFilterBtnHandler('')} >All</Dropdown.Item>
            <Dropdown.Item onSelect={() => premiumFilterBtnHandler('0')} >Free</Dropdown.Item>
            <Dropdown.Item onSelect={() => premiumFilterBtnHandler('1')} >Premium</Dropdown.Item>
          </DropdownButton>

        </Col>
        <Col md="3">
          <span style={{ display: 'block', marginBottom: '-15px' }}>Last Updated:</span>
          <DropdownButton
            id="template-updated-sort"
            title={updatedSort === 'desc' ? 'Newest First' : updatedSort === 'asc' ? 'Oldest First' : 'Default'}
            variant={updatedSort ? 'primary' : 'secondary'}
          >
            <Dropdown.Item onSelect={() => updatedSortBtnHandler('')}>Default</Dropdown.Item>
            <Dropdown.Item onSelect={() => updatedSortBtnHandler('desc')}>Newest First</Dropdown.Item>
            <Dropdown.Item onSelect={() => updatedSortBtnHandler('asc')}>Oldest First</Dropdown.Item>
          </DropdownButton>
        </Col>
      </Row>
      <Row>
        <Col className={loading === 'loading' ? 'blur' : ''}>
          <ToolkitProvider
            keyField="data.id"
            data={templates}
            columns={columns}
            search
            exportCSV
          >
            {
              props => (
                <div className='templateListTable'>
                  {/* <ExportCSVButton {...props.csvProps}>Export CSV!!</ExportCSVButton>
                  <hr /> */}
                  {/* <span>Input something at below input field:</span> */}
                  <SearchBar {...props.searchProps} />
                  <hr />
                  <BootstrapTable
                    {...props.baseProps}
                    filter={filterFactory()}
                    pagination={paginationFactory(options)}
                  />
                </div>
              )
            }
          </ToolkitProvider>
        </Col>
      </Row>
    </Container>
  );
}

export default TemplateList;
